<mat-card class="share-csv-card">
    <mat-card-header class="d-flex align-items-center justify-content-center mb-3">
      <mat-card-title>Share CSV</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="shareCsvForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="EmailIds" placeholder="Enter recipient's email">
            <mat-error *ngIf="shareCsvForm.get('EmailIds')?.hasError('required')">
              Email is required.
            </mat-error>
            <mat-error *ngIf="shareCsvForm.get('EmailIds')?.hasError('EmailIds')">
              Please enter a valid email address.
            </mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Subject</mat-label>
            <input matInput formControlName="Subject" placeholder="Enter subject">
            <mat-error *ngIf="shareCsvForm.get('Subject')?.hasError('required')">
              Subject is required.
            </mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Message</mat-label>
            <textarea matInput formControlName="Body" placeholder="Enter your message"></textarea>
            <mat-error *ngIf="shareCsvForm.get('Body')?.hasError('required')">
              Message is required.
            </mat-error>
          </mat-form-field>
        </div>
  
        <div class="form-row">
          <button mat-raised-button type="submit" [disabled]="shareCsvForm.invalid" class="full-width" style="background-color: #286ba5;color: white;">
            Send
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  